import { Component, Input, ViewEncapsulation } from '@angular/core';

export enum ImageDetailEnum {
  routingNumber = 'routing-number',
  accountNumber = 'account-number',
}
@Component({
  selector: 'app-check-reference-popover',
  templateUrl: './check-reference-popover.component.html',
  styleUrls: ['./check-reference-popover.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CheckReferencePopoverComponent {
  @Input() isTouch = false;
  @Input() imageDetail = ImageDetailEnum.routingNumber;
  @Input() dismissPopover: () => void;
  ImageDetailEnum = ImageDetailEnum;

  constructor() {}
}
